import { cx } from '@emotion/css';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { FC } from 'react';

import { AgencySearchInput } from './AgencySearchInput';
import * as S from './styles';

type AgencySearchBlockProps = {
  className?: string;
  trackingPage: string;
};

export const AgencySearchBlock: FC<AgencySearchBlockProps> = (props) => {
  const { className } = { ...props };
  const { t } = useTranslation(['common', 'agency']);

  return (
    <S.Shape
      className={cx(className, 'bg-primary-500 lg:p-16 py-16 px-8 text-center')}
      data-testid="agency-search-block">
      <header className="mb-8">
        <S.Title className="bold text-neutral-100">{t('common:agencySearchBlock.headline')}</S.Title>
        <p className="text-primary-300">{t('common:agencySearchBlock.subHeadline_V2')}</p>
      </header>
      <div className="layout-row layout-align-center-stretch">
        <AgencySearchInput />
      </div>
    </S.Shape>
  );
};
